export default function SelecJuego({ nombre, frase,idJuego, icono, color, clicked}: { nombre: any; frase:any; idJuego:any; icono:any; color:any; clicked:any;}) {


    return (
        <div className="selecJuego" onClick={() => setTimeout(clicked, 200)} >
            <div className="iconoWrap" style={{ background: color }}><img className={"iconoJuego "} src={"./"+icono}/></div>
            <div className="selecJuego__info">
                <h2 className="tituloJuego">{nombre}</h2>
                <h4 className="fraseJuego">{frase}</h4>
                <h3 className="labelJugar">Jugar</h3>
            </div>
        </div>

    );



   
  
}